<template>
  <div>
    <b-row class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>Email :</label>
        <ValidationProvider
          ref="vee-email"
          v-slot="{ errors, classes }"
          :name="'email'"
          rules="required|email"
        >
          <b-input
            type="email"
            autofocus
            :value="object.email"
            @input="$emit('updateObject', 'email', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
        <b-row class="my-2">
          <b-col cols="auto" class="pr-0">
            <font-awesome-icon icon="info-circle" />
          </b-col>
          <b-col class="pl-2">
            Votre email que vous avez utilisé pour télécharger l'application.
            <br />
            Vous devez avoir une connexion Internet pour enregistrer l'application après cette
            étape, vous pouvez l'utiliser hors ligne.
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
